"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import ItemElementStatus from "../../elements/ItemElementStatus.vue";
import ItemElementShops from "../../elements/ItemElementShops.vue";
import ItemElementMenu from "../../elements/ItemElementMenu.vue";
import ItemElementMeta from "../../elements/ItemElementMeta.vue";
import ItemElementFavorite from "../../elements/ItemElementFavorite.vue";
import ItemElementLauncher from "../../elements/ItemElementLauncher.vue";
import ItemElementDeployDate from "../../elements/ItemElementDeployDate.vue";
import ItemElementRenewBtn from "../../elements/ItemElementRenewBtn.vue";
import VdOnline from "@/views/virtualdesktopItems/components/VdOnline.vue";
import { AccountSessionMixins } from "@/service/account-session";
let VirtualDesktopItem = class extends Mixins(AccountSessionMixins) {
  mounted() {
  }
  get checkStatus() {
    if (this._item.status !== "open" && this._item.status !== "expired" || this._item.shops.length === 0) {
      return true;
    }
    return false;
  }
  get addShop() {
    if (this._item.status === "release" || this._item.marks.is("NOT_ALLOW_CREATE_SHOP")) {
      return false;
    } else {
      return true;
    }
  }
  createShop() {
    this.$emit("createShop", this._item);
  }
  moveShop() {
    this.$emit("moveshop", this._item);
  }
  editShop() {
    this.$emit("editshop", this._item);
  }
  changeName() {
    this.$emit("changename", this._item);
  }
  bindIP() {
    this.$emit("bindIP", this._item);
  }
  proxySetting() {
    this.$emit("proxySetting", this._item);
  }
  chooseAdmin() {
    this.$emit("chooseAdmin", this._item);
  }
  unstickToTop() {
    this.$emit("unstickToTop", this._item);
  }
  stickToTop() {
    this.$emit("stickToTop", this._item);
  }
  editGroup() {
    this.$emit("editGroup", this._item);
  }
  clearCache() {
    this.$emit("clearCache", this._item);
  }
  proxyShare() {
    this.$emit("proxyShare", this._item);
  }
  chargeTraffic() {
    this.$emit("chargeTraffic", this._item);
  }
  trafficDetail() {
    this.$emit("trafficDetail", this._item);
  }
  deleteVD() {
    this.$emit("deleteVD", this._item);
  }
  realDeleteVD() {
    this.$emit("realDeleteVD", this._item);
  }
  moveVD() {
    this.$emit("moveVD", this._item);
  }
  remoteLauncher() {
    this.$emit("remoteLauncher", this._item);
  }
  setFavorite(column) {
    this.$emit("setFavorite", column);
  }
  setUnFavorite(column) {
    this.$emit("setUnFavorite", column);
  }
  openForceDialog() {
    var _a, _b, _c;
    if (((_a = this.$session) == null ? void 0 : _a.type) === "account" || ((_b = this.$session) == null ? void 0 : _b.type) === "user" && ((_c = this.$session) == null ? void 0 : _c.permissions.is("SHOW_ALL_MENUS"))) {
      this.$emit("openForceDialog", this._item);
    }
  }
  toUrge() {
    this.$emit("urge", this._item);
  }
};
__decorateClass([
  PropSync("item")
], VirtualDesktopItem.prototype, "_item", 2);
VirtualDesktopItem = __decorateClass([
  Component({
    components: {
      ItemElementStatus,
      ItemElementShops,
      ItemElementMeta,
      ItemElementMenu,
      ItemElementFavorite,
      ItemElementLauncher,
      ItemElementDeployDate,
      ItemElementRenewBtn,
      VdOnline
    }
  })
], VirtualDesktopItem);
export {
  VirtualDesktopItem as default
};
